import React, { Suspense } from 'react'
import './App.less'
import { Layout } from 'antd'
import ApolloWrapper from './apolloWrapper'
import Router from './router/Router'
import { IPublicClientApplication } from '@azure/msal-browser'
import ProvideAppContext from './utils/AppContext'
import { MsalProvider } from '@azure/msal-react'
import { NotificationProvider } from './utils/NotificationContext'
import { ConfigCatProvider, createConsoleLogger, LogLevel, PollingMode } from 'configcat-react'

type AppProps = {
  pca: IPublicClientApplication
}

function App({ pca }: AppProps) {
  return (
    <Suspense fallback={<div>Loading ....</div>}>
      <MsalProvider instance={pca}>
        <Layout style={{ minHeight: '100vh' }}>
          <ConfigCatProvider
            sdkKey={process.env.REACT_APP_CONFIG_CAT_API_KEY ?? ''}
            pollingMode={PollingMode.AutoPoll}
            options={{
              logger: createConsoleLogger(LogLevel.Info),
              pollIntervalSeconds: process.env.REACT_APP_CONFIG_CAT_REFRESH_INTERVAL
                ? parseInt(process.env.REACT_APP_CONFIG_CAT_REFRESH_INTERVAL, 10)
                : 120,
            }}>
            <NotificationProvider>
              <ProvideAppContext>
                <ApolloWrapper>
                  <Router />
                </ApolloWrapper>
              </ProvideAppContext>
            </NotificationProvider>
          </ConfigCatProvider>
        </Layout>
      </MsalProvider>
    </Suspense>
  )
}

export default App
